import AdditionalInformation from './AdditionalInformation';
import VehicleAttributes from './VehicleAttributes';
import VehicleLocation from './VehicleLocation';

export default {
    AdditionalInformation,
    VehicleAttributes,
    VehicleLocation,
};
